import type { IconNode } from '../types';

/**
 * @name golf-driver
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSI2IiBjeT0iOSIgcj0iMiIgLz4KICA8cGF0aCBkPSJNNiAxMXYyIiAvPgogIDxwYXRoIGQ9Im0yMiAyLTkuMyAxNC4xYy0uNC42LTEgLjktMS43LjlINGEyIDIgMCAwIDAtMiAydjFhMiAyIDAgMCAwIDIgMmgyYzEuNiAwIDMuMS0uNyA0LjEtMi4xbDIuNi0zLjgiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/golf-driver
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const golfDriver: IconNode = [
  ['circle', { cx: '6', cy: '9', r: '2', key: '1x7ecr' }],
  ['path', { d: 'M6 11v2', key: 'dh4kw5' }],
  [
    'path',
    {
      d: 'm22 2-9.3 14.1c-.4.6-1 .9-1.7.9H4a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h2c1.6 0 3.1-.7 4.1-2.1l2.6-3.8',
      key: '162yko',
    },
  ],
];

export default golfDriver;
